import App from "./App"

function SanFrancisco(props) {
    return <App version='San Francisco' />
}
export default SanFrancisco
